<template>
  <div class="section section--login">
    <h2 class="section__title">Login</h2>
    <div class="section__container">
      <div class="section__content">
        <div class="details">
          <form @submit.prevent="login" v-if="!showTokenEntry">
            <label for="email">Email address</label>
            <input id="email" class="value" type="email" placeholder="Email" v-model="email" />
            <a class="control control--login" @click.prevent="login" href="javascript:void()">Email Login Code</a>
            <p><a @click.prevent="showTokenEntry = true" href="javascript:void()">Enter Code</a></p>
          </form>
          <form @submit.prevent="setToken" v-else>
            <label for="code">Login Code</label>
            <input id="code" class="value" type="token" placeholder="Code" v-model="token" />
            <a class="control control--login" @click.prevent="setToken"  href="javascript:void()">Login</a>
            <p><a @click.prevent="showTokenEntry = false" href="javascript:void()">Enter Email</a></p>
          </form>
        </div>
        <div class="info">
          <h3 class="info__title">Logging in</h3>
          <p>Sharebot emails you a login code to your Poshmark email address to verify your identity and log you in.</p>

          <p>If you no longer have access to your Poshmark email address, please contact support for assistance.</p>
        </div>
        <div class="controls" v-if="isLoggedIn">
          <a
            class="control control--pause"
            href="javascript:void(0)"
            @click="togglePaused"
            v-if="!isPaused"
          >Pause Sharing</a>
          <a
            class="control control--resume"
            href="javascript:void(0)"
            @click="togglePaused"
            v-if="isPaused"
          >Resume Sharing</a>
          <a
            class="control control--restart"
            href="javascript:void(0)"
            @click="restart"
          >Restart Sharing</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      email: '',
      token: '',
      showTokenEntry: false,
    };
  },
  methods: {
    login() {
      this.$store.dispatch('getLoginToken', this.email);
      this.$store.dispatch('startUpdater');
      this.showTokenEntry = true;
    },
    setToken() {
      this.$store.dispatch('updateLoginToken', this.token);
    },
  },
};
</script>
